import React from 'react'

const Footer = () => {
  return (
    <div className='d-flex justify-content-center align-items-center p-3 text-white' style={{borderTop:"1px solid white",backgroundImage:"linear-gradient(0deg,#000)"}}>
        <h5>Developed By The Geethasri Nimmadala</h5>
        </div>
  )
}

export default Footer;